/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-right': {
    width: 16,
    height: 16,
    viewBox: '0 0 35 35',
    data: '<path pid="0" d="M27.051 17L9.905 0 8.417 1.414l16.257 16.293L8.363 34l1.551 1.414 17.137-17z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/arrow-right.js